{
  "hero": {
    "eyebrow": "Science",
    "title": "Pourquoi un suivi mobile lié au lieu compte.",
    "lead": "La qualité de l'eau change dans l'espace et après la pluie. AquaWorks transforme des lectures répétables le long d'un trajet en cartes et tendances que les étudiants peuvent interpréter — sans prétendre à une certitude de laboratoire."
  },
  "problem": {
    "title": "Contexte et problème",
    "body": "L'échantillonnage manuel ne capture souvent que quelques points fixes. Dans les milieux liés aux eaux pluviales, la pluie peut déplacer sédiments, particules routières, nutriments et autres matières vers étangs et eaux réceptrices. Les conditions peuvent différer de quelques mètres et évoluer vite après les orages.",
    "points": [
      "Des recherches régionales lient des composés dérivés des pneus comme la 6PPD-quinone à des impacts aigus sur le saumon coho après la pluie — d'où l'importance des voies de ruissellement.",
      "La pollution nutritive peut provoquer des blooms algaux et des conditions d'oxygène faible.",
      "La turbidité est un indicateur de terrain pragmatique en Phase 1 : les particules en suspension affectent les habitats et peuvent transporter phosphore, métaux et autres polluants."
    ]
  },
  "campus": {
    "title": "Contexte des eaux pluviales sur le campus de Vancouver",
    "body": "Le plan de gestion intégrée des eaux pluviales du campus de Vancouver et les rapports de durabilité soulignent la qualité des eaux pluviales comme objectif à long terme. Les travaux SEEDS sur jardins de pluie et infrastructures vertes montrent un besoin continu de mesures liées à la pluie : température, pH, conductivité, oxygène dissous et turbidité.",
    "note": "AquaWorks complète les infrastructures fixes par des observations mobiles et spatialement distribuées lors de tests contrôlés — sans s'approprier les programmes de surveillance campus."
  },
  "parameters": {
    "eyebrow": "Capteurs Phase 1",
    "title": "Cinq indicateurs clés de qualité de l'eau",
    "note": "Ils caractérisent des conditions générales et des variations spatiale ou temporelle. Ils ne confirment pas de contaminants spécifiques ni la conformité réglementaire.",
    "items": {
      "temperature": { "name": "Température", "description": "Influence l'oxygène dissous, les processus biologiques et le comportement des autres indicateurs." },
      "ph": { "name": "pH", "description": "Acidité ou alcalinité, sensible à l'activité biologique et au contexte." },
      "turbidity": { "name": "Turbidité", "description": "Signal optique des particules en suspension — utile pour les motifs de ruissellement." },
      "conductivity": { "name": "Conductivité électrique", "description": "Indique le contenu ionique dissous ; utile pour comparer des points le long d'un trajet." },
      "dissolvedOxygen": { "name": "Oxygène dissous", "description": "Essentiel à la vie aquatique ; vérifié selon les procédures fabricant en Phase 1." }
    }
  },
  "spatial": {
    "title": "Observation spatiale et temporelle",
    "body": "Les lectures sont liées à l'horodatage et à des références spatiales — waypoints, segments, GPS si possible, ou zones d'essai. Les comparaisons avant/après pluie sur le même trajet rendent le changement visible."
  },
  "viz": {
    "title": "Du CSV au récit spatial",
    "body": "Fichiers bruts et traités restent séparés. Sorties : cartes de trajet, tendances temporelles et paramétriques, et au moins une carte spatiale où couleur ou hauteur représente un indicateur. Les hypothèses d'interpolation sont documentées ; les points de mesure restent visibles."
  },
  "sdgs": {
    "title": "Alignement ODD",
    "lead": "Éducation, eau propre, innovation, communautés durables, production responsable, littératie climatique, vie aquatique et partenariats.",
    "items": {
      "education": "Éducation de qualité",
      "water": "Eau propre et assainissement",
      "innovation": "Industrie, innovation et infrastructure",
      "cities": "Villes et communautés durables",
      "consumption": "Consommation et production responsables",
      "climate": "Mesures relatives à la lutte contre les changements climatiques",
      "lifeBelowWater": "Vie aquatique",
      "partnerships": "Partenariats pour la réalisation des objectifs"
    }
  },
  "sources": {
    "title": "Références sélectionnées",
    "lead": "Le cadrage s'appuie sur la recherche évaluée par les pairs, des guides provinciaux, des documents de planification du campus de Vancouver et des rapports SEEDS cités dans la proposition."
  }
}
